"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _video = _interopRequireDefault(require("video.js"));
require("video.js/dist/video-js.css");
require("videojs-hls-quality-selector");
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var VideoPlayer = function VideoPlayer(_ref) {
  var options = _ref.options,
    videoUrl = _ref.videoUrl;
  var playerRef = (0, _react.useRef)(null);

  // Determine the video source type based on the video URL
  var videoSourceType = videoUrl !== null && videoUrl !== void 0 && videoUrl.includes('.m3u8') ? 'application/x-mpegURL' : 'video/mp4';
  var videoJsOptions = _objectSpread(_objectSpread({}, options), {}, {
    techOrder: ['html5'],
    html5: {
      vhs: {
        overrideNative: true,
        fastQualityChange: true
      }
    },
    sources: [{
      src: videoUrl,
      type: videoSourceType
    }]
  });

  // Initialize video.js player once the component is mounted
  (0, _react.useEffect)(function () {
    var player = playerRef.current;
    if (player) {
      var videoPlayer = (0, _video["default"])(player, videoJsOptions);
      videoPlayer.ready(function () {
        videoPlayer.volume(_constants.DEFAULT_VOLUME);
        videoPlayer.hlsQualitySelector({
          displayCurrentQuality: true
        });
      });
      return function () {
        if (videoPlayer) {
          videoPlayer.dispose();
        }
      };
    }
  }, [videoUrl]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-vjs-player": true
  }, /*#__PURE__*/_react["default"].createElement("video", {
    ref: playerRef,
    className: "video-js vjs-default-skin vjs-big-play-centered"
  }, "Your browser does not support the video file."));
};
var _default = exports["default"] = VideoPlayer;